module.exports = __webpack_public_path__ + "static/media/app-payment-view.e99df941.jpeg";